import { AppProvider } from '@edx/frontend-platform/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Route, Routes, useLocation } from 'react-router-dom';
import { FooterSlot } from '@edx/frontend-component-footer';

import CatalogHeader from './header/CatalogHeader';
import AuthenticatedHomeRedirect from './components/AuthenticatedHomeRedirect';
import PublicCatalogFooter from './components/PublicCatalogFooter';
import RouteScrollManager from './components/RouteScrollManager';
import HomePage from './home/HomePage';
import CatalogPage from './catalog/CatalogPage';
import CourseAboutPage from './course-about/CourseAboutPage';
import AboutPage from './static-pages/AboutPage';
import FaqPage from './static-pages/FaqPage';
import HelpPage from './static-pages/HelpPage';
import TermsPage from './static-pages/TermsPage';
import PrivacyPage from './static-pages/PrivacyPage';
import NotFoundPage from './not-found-page/NotFoundPage';
import { ROUTES } from './routes';

const queryClient = new QueryClient();
const MARKETING_STATIC_ROUTES: string[] = [
  ROUTES.ABOUT,
  ROUTES.FAQ,
  ROUTES.HELP,
  ROUTES.LEGAL_TERMS,
  ROUTES.LEGAL_PRIVACY,
];

const CatalogAppShell = () => {
  const location = useLocation();
  const isHomePage = location.pathname === ROUTES.HOME;
  const isMarketingRoute = location.pathname === ROUTES.HOME
    || location.pathname.startsWith(ROUTES.COURSES)
    || MARKETING_STATIC_ROUTES.includes(location.pathname);

  return (
    <div className={`catalog-app d-flex flex-column min-dvh-100${isHomePage ? ' catalog-app--landing' : ''}`}>
      <RouteScrollManager />
      <CatalogHeader />
      <main id="main" className="catalog-app__main d-flex flex-column flex-grow-1">
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={(
              <AuthenticatedHomeRedirect>
                <HomePage />
              </AuthenticatedHomeRedirect>
            )}
          />
          <Route path={ROUTES.COURSES} element={<CatalogPage />} />
          <Route path={ROUTES.COURSE_ABOUT} element={<CourseAboutPage />} />
          <Route path={ROUTES.ABOUT} element={<AboutPage />} />
          <Route path={ROUTES.FAQ} element={<FaqPage />} />
          <Route path={ROUTES.HELP} element={<HelpPage />} />
          <Route path={ROUTES.LEGAL_TERMS} element={<TermsPage />} />
          <Route path={ROUTES.LEGAL_PRIVACY} element={<PrivacyPage />} />
          <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
        </Routes>
      </main>
      {isMarketingRoute ? <PublicCatalogFooter /> : <FooterSlot />}
    </div>
  );
};

const App = () => (
  <AppProvider>
    <QueryClientProvider client={queryClient}>
      <CatalogAppShell />
    </QueryClientProvider>
  </AppProvider>
);

export default App;
